import {Backdrop, BackdropProps, CircularProgress} from '@mui/material'

type DefaultLoadingComponentProps = Partial<BackdropProps> & {overlapScreen?: boolean}

export const DefaultLoadingComponent: React.FC<DefaultLoadingComponentProps> = ({
  overlapScreen = true,
  ...backdropProps
}) => {
  return (
    <Backdrop
      open
      sx={({palette, zIndex}) => ({
        color: palette.primary.main,
        ...(overlapScreen ? {zIndex: zIndex.drawer + 1} : {})
      })}
      {...backdropProps}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}
